export default class RecapAttendanceActions {

    static NEW_DATA = 'NEW_DATA';
    static RESET_DATA = 'RESET_DATA';
    static GET_HELPER_RECAPATTENDANCE = 'GET_HELPER_RECAPATTENDANCE';
    static GET_DATA = 'GET_DATA';
    static SET_TRACKING = 'SET_TRACKING';
    static LOADING_DETAILS = 'LOADING_DETAILS';
    static LOADED_DETAILS = 'LOADED_DETAILS';

    static loadingDetails(){
      return {
        type:RecapAttendanceActions.LOADING_DETAILS
      }
    }

    static loadedDetails(data){
      return {
        type:RecapAttendanceActions.LOADED_DETAILS,
        payload:data,
      }
    }

    static new(){
      return {
        type:RecapAttendanceActions.NEW_DATA
      }
    }
    static process(){
      return {
        type:RecapAttendanceActions.GET_DATA
      }
    }

    static setTracking(data){
      return {
        type:RecapAttendanceActions.SET_TRACKING,
        payload:data
      }
    }

    static reset(){
      return {
        type:RecapAttendanceActions.RESET_DATA
      }
    }
    static helper(data){
      return {
        type:RecapAttendanceActions.GET_HELPER_RECAPATTENDANCE,
        payload:data
      }
    }
    
  }
  
  